import React, {Component} from 'react'
import {Formik} from 'formik'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {editEndpointList} from '../../actions/endpoints'
import { CSSTransition } from "react-transition-group"


class TableForm extends Component{
    constructor(props){
        super(props)
        this.history = []
        this.state = {
            list: props.list
        }
        this.addNew = this.addNew.bind(this)
        this.addTr  = this.addTr.bind(this)
        this.addTd  = this.addTd.bind(this)
        this.addIn  = this.addIn.bind(this)
        this.handleUndo = this.handleUndo.bind(this)
    }

    addNew(){
        this.setState( prev => {
            this.history.push( prev )
            return {
                list: prev.list.concat([{
                    model: "",
                    property: "",
                    accessType: "",
                    permission: "",
                    principalType: "",
                    principalId: ""
                }])
            }
        })
    }

    handleUndo(){
        // TODO
    }

    addTr(l, i, h, v){
        let colsCfg = this.props.colsCfg
        let cols = Object.keys(colsCfg)
 
        return <tr key={i}>
            {
                Object.keys(l).map(k => {
                    return cols.indexOf(k) !== -1 ?
                    this.addTd(k,i,h,v): null
                })
            }
        </tr>
    }

    addTd(k, i, h, v){
        return <td key={k+i}>
            {
                this.addIn(k,i,h,v)
            }
        </td>
    }

    addIn(k, i, h, v){
        let colsCfg = this.props.colsCfg
        return colsCfg[k].type === 'string' ?
        <input 
            name={k+'>>'+i}
            onChange={h} 
            value={v[k+'>>'+i]}
            className="form-control"
        />: 
        <select 
            name={k+'>>'+i}
            onChange={h} 
            value={v[k+'>>'+i]}
            className="form-control"
        >
            {
                colsCfg[k].values.map( (v,j)=>
                    <option 
                        key={k+'>>'+i+'>>'+j}
                        value={colsCfg[k].values[j]}
                    >
                        {colsCfg[k].values[j]}
                    </option>
                )
            }
        </select>  
    }

    render(){
        console.dir(this.state.list)
        let dispatch = this.props.dispatch
        let ep = this.props.endpoint
        let ac = this.props.access
        let list = this.state.list
        let cols = Object.keys(this.props.colsCfg)
        let initVal = {}
        if(list.length > 0){
            list.forEach((l,i) => {
                for(var n in l){
                    initVal[n + '>>' + i] = l[n]
                }
            })
        }  
        
        return (
            <CSSTransition
                in={true}
                appear={true}
                timeout={500}
                classNames="fade"
            >
            <Formik
                initialValues = {initVal}
                onSubmit={ values => {
                    // Do not mutate the state. Create a new array.
                    let finalValues = list.concat([])
                    for(var n in values){
                        let ndx = Number(n.split('>>')[1])
                        let prp = n.split('>>')[0]
                        finalValues[ndx][prp] = values[n]
                    }
                    finalValues.forEach(fv => {
                        console.dir(fv)
                        dispatch(
                            editEndpointList(ep.id,ep.name,ac,fv))
                            .then(console.log('...done'))
                        }
                    )
                }}
                render={
                    ({
                        handleSubmit,
                        handleChange,
                        values
                    }) => {
                        return <div id="form-acl" className="mr-5">
                            <table className="table table-light" id="table-acl">
                                <tbody>
                                    <tr>
                                        {cols.map(c => 
                                        <th key={c}>{c}</th>)}
                                    </tr>
                                    {/* <tr>
                                        <td colspan='6' className="">
                                            <button type="button" onClick={this.addNew} className="btn btn-custom add-btn mr-2 ml-1 mb-3 mt-3">New</button>
                                            <button type="submit" onClick={handleSubmit} className="btn btn-success mr-2 mb-3 mt-3">Save</button>
                                            <button type="submit" onClick={this.handleUndo} className="btn btn-warning mb-3 mt-3"><i className="fa fa-undo"></i></button>
                                        </td>
                                    </tr> */}
                                    {
                                        list.map((l,i) => 
                                        this.addTr(l,i,handleChange,values))
                                    }
                                </tbody>
                            </table>
                            <div className="acl-absolute-btn">
                            <button type="button" onClick={this.addNew} className="btn btn-custom add-btn mr-1" style={{padding: '6px 10px'}}>Add Model</button>
                            <button type="submit" onClick={handleSubmit} className="btn btn-success add-btn mr-1" style={{padding: '6px 10px'}}>Save</button>
                            <button type="submit" onClick={this.handleUndo} className="btn btn-warning"><i className="fa fa-undo"></i></button>
                            </div>
                            
                        </div>
                        
                    }
                }
                
            />

            
            </CSSTransition>
        )
    }
}


export default withRouter(connect()(TableForm))


// WEBPACK FOOTER //
// ./src/components/utilities/TableForm.js